import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Empty(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "Empty",
      fill: "none",
      sx,
      viewBox,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M12 8v1h-1.6068l.0757.05434-.58319.81233L8.39999 8.8c.11503-.11503.24659-.23005.38994-.33556.14491-.10667.30186-.20361.46593-.28101C9.4939 8.07115 9.74695 8 9.99999 8H12Zm.1143 3.4667.5832-.8124 2.9714 2.1334-.5832.8123-2.9714-2.1333Zm5.2 3.7333.5832-.8123 2.9714 2.1333-.5832.8123L17.3143 15.2Zm5.2 3.7333.5832-.8123.9114.6543.9245-.6436.5714.8207L24 20l-1.4857-1.0667Zm5.2476-1.5523-.5714-.8207 3.0096-2.0953.5713.8207-3.0095 2.0953Zm5.2667-3.6667-.5714-.8207 3.0095-2.0952.5714.8206-3.0095 2.0953Zm5.2666-3.6667-.5713-.82067.3247-.22606C38.0325 9.00029 38.0163 9 38 9h-2V8h2c.4099 0 .7673.10503 1.0723.28818.1496.08991.2867.19865.411.32303.0911.09106.1754.19049.2528.29706.0219.03002.0431.06061.0639.09173l-1.5048 1.0476ZM15 8v1h4V8h-4Zm7 0v1h4V8h-4Zm7 0v1h4V8h-4ZM8.5 11.8571V10h1v1.8571h-1ZM40 10v1.8571h-1V10h1ZM8.5 18.3571v-3.7142h1v3.7142h-1ZM40 14.6429v3.7142h-1v-3.7142h1ZM8.5 24.8571v-3.7142h1v3.7142h-1ZM40 21.1429v3.7142h-1v-3.7142h1Zm-31.5 6.5h1V29h1.6786v1H8.5v-2.3571Zm31.5 0V30h-2.6786v-1H39v-1.3571h1ZM18.8036 30h-4.3572v-1h4.3572v1Zm7.625 0h-4.3572v-1h4.3572v1Zm7.625 0h-4.3572v-1h4.3572v1Z",
            fill: theme.vars.palette.primary.light,
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M44 24v14c0 1-1 2-2 2H6c-1 0-2-1-2-2V24c0-1 1-2 2-2h9c.8 0 1.4.4 1.8 1l2.4 5h9.6l2.4-5c.4-.6 1-1 1.8-1h9c1 0 2 1 2 2Z",
            fill: theme.vars.palette.primary.dark
          }
        )
      ]
    }
  );
}
Empty.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Empty"
};
validateTidalLicense();
export {
  Empty
};
//# sourceMappingURL=Empty.js.map
